import React, { useContext, useState } from "react";
import { FaBook, FaStar, FaUser, FaChartBar, FaHistory, FaTimes, FaChevronRight } from "react-icons/fa";
import "../../styles/components-styles/sidebar-styles/HighYieldTextbookSidebar.css";
import { SidebarContext } from "../../contexts/SidebarContext";

function HighYieldTextbookSidebar() {
    const { showHighYieldSidebar, toggleHighYieldSidebar } = useContext(SidebarContext);
    const [selectedList, setSelectedList] = useState("category");
    const [selectedCategory, setSelectedCategory] = useState(null);

    const lists = {
        category: [
            "Administration and health informatics",
            "Dermatology",
            "Ear, nose and throat",
            "Evidence based clinical practice",
            "Medicine",
            "Ophthalmology",
            "Paediatrics",
            "Psychiatry",
            "Surgical and musculoskeletal problems",
            "Women's health"
        ],
        starredNotes: ["Important Topics", "Frequently Missed", "Marked for Review"],
        userNotes: ["My Annotations", "Saved Explanations", "Personal Highlights"],
        performanceByTopic: ["High Scoring Topics", "Low Scoring Topics", "Trending Topics"],
        examPerformance: ["Recent Exam Scores", "Progress Reports", "Global Comparisons"],
        history: ["Recent Questions", "Last 10 Revisions", "Past Tests"]
    };

    const selectCategory = (category) => setSelectedCategory(category);

    return (
        <div className={`high-yield-text-book-sidebar-container ${showHighYieldSidebar ? "open" : "closed"}`}>
            <div className="high-yield-text-book-sidebar-header">
                <FaBook title="Category" onClick={() => setSelectedList("category")} />
                <FaStar title="Starred Notes" onClick={() => setSelectedList("starredNotes")} />
                <FaUser title="User Notes" onClick={() => setSelectedList("userNotes")} />
                <FaChartBar title="Performance by Topic" onClick={() => setSelectedList("performanceByTopic")} />
                <FaChartBar title="Exam Performance" onClick={() => setSelectedList("examPerformance")} />
                <FaHistory title="History" onClick={() => setSelectedList("history")} />
                <FaTimes className="close-icon" onClick={() => {
                    toggleHighYieldSidebar()
                }} title="Close" />
            </div>
            
            <input type="text" placeholder="Search..." className="sidebar-search" />
            
            <h3 className="high-yield-text-book-sidebar-category-header">{selectedList.replace(/([A-Z])/g, ' $1').trim()}</h3>
            {selectedCategory && <p className="selected-category">{selectedCategory}</p>}
            
            <ul className="high-yield-text-book-sidebar-list">
                {lists[selectedList].map((item, index) => (
                    <li key={index} className="high-yield-text-book-sidebar-item" onClick={() => selectCategory(item)}>
                        {item}
                        <FaChevronRight className="arrow-icon" />
                    </li>
                ))}
            </ul>
        </div>
    );
}

export default HighYieldTextbookSidebar;
